import React, { useEffect, useState } from "react";
import { FaUser, FaRobot } from "react-icons/fa"; // Importing icons from react-icons
import BotAvatar from "../BotAvatar/BotAvatar";
import AnvyImage from "@workspace/main/src/assets/images/Anvy 1.png";

const Transcript = ({ chatHistory, aiAlias = "AI", userAlias = "User" }) => {
  const mapChatHistoryToChatConversation = () => {
    const chatHistorySliced = chatHistory.slice(1); // Remove the first element
    return chatHistorySliced.map((chat, index) => {
      let chatAlias = chat?.type === "ai" ? aiAlias : userAlias;
      let content = "";

      if (chat?.content) {
        // Check if it is a JSON string
        try {
          const parsedContent = JSON.parse(chat?.content);
          content = parsedContent?.interviewer_output || chat?.content; // Fallback to original content if no output
        } catch (e) {
          content = chat?.content;
        }
      }

      return (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: chat?.type === "ai" ? "flex-start" : "flex-end",
            margin: "15px 0", // Increased gap between messages
            width: "100%",
          }}
        >
          {/* Bot Chat */}
          {chat?.type === "ai" && (
            <div
              style={{ display: "flex", alignItems: "center", maxWidth: "80%" }}
            >
              <div style={{ marginRight: "10px" }}>
                {/* <FaRobot size={24} color="#00bcd4" /> */}
                <BotAvatar avatarImg={AnvyImage} size="35px" />
              </div>
              <div
                style={{
                  backgroundColor: "#e0f7fa",
                  borderRadius: "10px",
                  padding: "10px 15px",
                  flex: 1, // Makes the bubble flexible in width
                  wordWrap: "break-word",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s ease",
                  fontSize: chatAlias === "Interviewer" ? "16px" : "14px",
                }}
              >
                <strong>{chatAlias}</strong>: {content}
              </div>
            </div>
          )}

          {/* Human Chat */}
          {chat?.type !== "ai" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                maxWidth: "80%", // Limits maximum width of bubbles
              }}
            >
              <div
                style={{
                  backgroundColor: "#ffe0b2",
                  borderRadius: "10px",
                  padding: "10px 15px",
                  flex: 1, // Makes the bubble flexible in width
                  wordWrap: "break-word",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s ease",
                  marginRight: "10px",
                  fontSize: chatAlias === "Interviewer" ? "16px" : "14px",
                }}
              >
                <strong>{chatAlias}</strong>: {content}
              </div>
              <FaUser size={24} color="#4caf50" />
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <>
      {chatHistory && chatHistory.length > 1 && (
        <div
          style={{
            padding: "20px",
            maxHeight: "100%",
            overflowY: "auto",
            borderRadius: "10px",
            position: "relative",
          }}
        >
          {mapChatHistoryToChatConversation()}
        </div>
      )}
    </>
  );
};

export default Transcript;
